export function contentSidePadding(breakpoints, spacing) {
  return {
    [breakpoints.down('md')]: {
      paddingInlineStart: spacing(3),
      paddingInlineEnd: spacing(3)
    },
    [breakpoints.up('md')]: {
      paddingInlineStart: spacing(4),
      paddingInlineEnd: spacing(4)
    },
    [breakpoints.up('xl')]: {
      paddingInlineStart: spacing(6),
      paddingInlineEnd: spacing(6)
    }
  };
}
export function contentTopPadding(spacing) {
  return {
    paddingTop: spacing(3)
  };
}
export function headerPadding(breakpoints, spacing) {
  return {
    [breakpoints.down('md')]: {
      paddingInline: spacing(3)
    },
    [breakpoints.up('md')]: {
      paddingInline: spacing(4)
    },
    [breakpoints.up('xl')]: {
      paddingInline: spacing(6)
    }
  };
}
export function tabBarPadding(breakpoints, spacing) {
  return {
    [breakpoints.down('md')]: {
      paddingInline: spacing(1)
    },
    [breakpoints.up('md')]: {
      paddingInline: spacing(2)
    },
    [breakpoints.up('xl')]: {
      paddingInline: spacing(4)
    }
  };
}
export function contentToolbarActions(breakpoints, spacing) {
  return {
    [breakpoints.down('md')]: {
      paddingInline: spacing(3)
    },
    [breakpoints.up('md')]: {
      paddingInline: spacing(4)
    },
    [breakpoints.up('xl')]: {
      paddingInline: spacing(6)
    }
  };
}
export function contentTablePadding(breakpoints, spacing, hasSelectColumn) {
  return {
    [breakpoints.down('md')]: {
      paddingInline: hasSelectColumn ? spacing(1) : spacing(2.5)
    },
    [breakpoints.up('md')]: {
      paddingInline: hasSelectColumn ? spacing(2) : spacing(3.5)
    },
    [breakpoints.up('xl')]: {
      paddingInline: hasSelectColumn ? spacing(4) : spacing(5.5)
    }
  };
}
export function contentPaginationPadding(breakpoints, spacing) {
  // content padding - 1 base unit to get the results text to line up. pagination footer has 8px InlineStart margin
  return {
    [breakpoints.down('md')]: {
      paddingInlineStart: spacing(2),
      paddingInlineEnd: spacing(3)
    },
    [breakpoints.up('md')]: {
      paddingInlineStart: spacing(3),
      paddingInlineEnd: spacing(4)
    },
    [breakpoints.up('xl')]: {
      paddingInlineStart: spacing(5),
      paddingInlineEnd: spacing(6)
    }
  };
}